import * as dat from "dat.gui";
import { APP_ENVIRONMENT } from "../../config/config";
import { GUI } from "dat.gui";
import { Vector3 } from "./types";

export class DrawUISingleton {
    private static _instance: DrawUISingleton;

    private drawUI: dat.GUI | undefined;

    public static getInstance(): DrawUISingleton {
        if (!DrawUISingleton._instance) {
            DrawUISingleton._instance = new DrawUISingleton();
        }
        return DrawUISingleton._instance;
    }

    public getDrawUI(): dat.GUI | null {
        if (APP_ENVIRONMENT === "development") {
            if (!this.drawUI) {
                this.drawUI = new dat.GUI({ width: 500 });
            }
            return this.drawUI;
        } else {
            return null;
        }
    }
}

export function DatGuiAddVec3(
    datGui: GUI,
    vec: Vector3,
    name: string,
    rangeMin: number,
    rangeMax: number,
    bSeparateFolder = false,
    bListen = false,
) {
    let folder = datGui;
    if (bSeparateFolder) {
        folder = datGui.addFolder(name);
    }
    let g = folder
        .add(vec, "x", rangeMin, rangeMax)
        .name(name + `X`)
        .step(0.01);
    if (bListen) g.listen();
    g = folder
        .add(vec, "y", rangeMin, rangeMax)
        .name(name + `Y`)
        .step(0.01);
    if (bListen) g.listen();
    g = folder
        .add(vec, "z", rangeMin, rangeMax)
        .name(name + `Z`)
        .step(0.01);
    if (bListen) g.listen();
}
